import React from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { useTranslation } from 'react-i18next';
import './StatusBar.css';

const StatusBar = () => {
  const { t } = useTranslation('common');
  const { notification, hideNotification } = useNotification();

  if (!notification) {
    return null;
  }

  const getStatusIcon = (type) => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  return (
    <div className={`status-bar-notification ${notification.type}`}>
      <span className="status-icon">{getStatusIcon(notification.type)}</span>
      <span className="status-message">{notification.message}</span>
      <button
        className="status-close"
        onClick={hideNotification}
        aria-label={t('statusBar.closeNotification')}
      >
        ×
      </button>
    </div>
  );
};

export default StatusBar;